import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/olivers/Nav";
import Hero from "@/components/olivers/Hero";
import Marquee from "@/components/olivers/Marquee";
import WalkIn from "@/components/olivers/WalkIn";
import Services from "@/components/olivers/Services";
import About from "@/components/olivers/About";
import Why from "@/components/olivers/Why";
import Gallery from "@/components/olivers/Gallery";
import InstagramStrip from "@/components/olivers/InstagramStrip";
import Reviews from "@/components/olivers/Reviews";
import Contact from "@/components/olivers/Contact";
import FinalCTA from "@/components/olivers/FinalCTA";
import Footer from "@/components/olivers/Footer";
import MobileBar from "@/components/olivers/MobileBar";
import InstagramPopup from "@/components/olivers/InstagramPopup";
import { lenisRef } from "@/components/olivers/scroll";

const TICKER = [
  "Walk ins welcome",
  "Good cuts. No BS.",
  "St Kilda VIC",
  "A St Kilda institution",
  "Est. 2012",
  "Fades / Cuts / Beards",
  "Free drink with every cut",
];

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15 });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <div className="bg-paper font-sans text-ink antialiased selection:bg-rust selection:text-paper">
      <div className="grain" aria-hidden="true" />
      <Nav />
      <main className="pb-16 md:pb-0">
        <Hero />
        <Marquee items={TICKER} testId="hero-marquee" />
        <WalkIn />
        <Services />
        <About />
        <Why />
        <Gallery />
        <InstagramStrip />
        <Reviews />
        <Marquee items={TICKER} dark={false} reverse testId="footer-marquee" />
        <Contact />
        <FinalCTA />
      </main>
      <Footer />
      <MobileBar />
      <InstagramPopup />
    </div>
  );
}

export default App;
